export function Sonner({ ...props }) {
  return null;
}

export { Sonner as Toaster };
